import { render, staticRenderFns } from "./BetgameAdconsent.vue?vue&type=template&id=57d36954&scoped=true"
import script from "./BetgameAdconsent.vue?vue&type=script&lang=js"
export * from "./BetgameAdconsent.vue?vue&type=script&lang=js"
import style0 from "./BetgameAdconsent.vue?vue&type=style&index=0&id=57d36954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d36954",
  null
  
)

export default component.exports